<template>
    <upload-source-data-form></upload-source-data-form>
</template>
<style lang="scss">
    $color: black;
    h1 {
        color: $color;
    }
</style>
<script>
    import UploadSourceDataForm from './../components/UploadSourceDataForm.vue';
    import {createNamespacedHelpers} from 'vuex';

    const {mapActions} = createNamespacedHelpers('riskIndex');
    export default {
        name:       'uploadSourceDataView',
        components: {
            UploadSourceDataForm
        },
        methods:    {
            ...mapActions([
                'loadSourceData', 'loadRiskAreaData'
            ])
        },
        mounted() {
            this.loadSourceData();
            this.loadRiskAreaData();
        }
    };
</script>
